<template>
  <div>
    <!-- Page Header Start -->
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="BookingSelectList" 
          :extra-items="[
            {
              text: bookingPresetName,
              to: 'BookingList',
              params: $route.params.id
            },
            '基本設定'
          ]" 
        />
      </div>
    </div>
    <!-- Page Header End -->

    <!-- Form Start -->
    <div class="email-wrapper wrapper">
      <div class="row bg-white">
        <div class="col-md-2 mail-sidebar pt-3">
          <div class="menu-bar">
            <ul class="menu-items">
              <li
                :class="{
                  active: step == '',
                  'has-checkbox': true,
                  'has-checkbox--checked': bookingPresetId,
                }"
                @click="goToStep('')"
              >
                <a>基本設定</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-10 main-view">
          <b-overlay :show="showLoading">
            <b-card>
              <!-- 基本資料 section start -->
              <!-- 歡迎頁 -->
              <section v-if="step == ''">
                <div class="row d-flex mb-4 mb-xl-2">
                  <h4 class="col-12 col-xl-6 mb-3 font-weight-bold">
                    {{ bookingPresetName }}
                  </h4>
                  <div class="col-12 col-xl-6 mb-3">
                    <AppSingleSelect
                      v-model="branch"
                      :options="branchOptions"
                      @input="formatAndFetchPreset"
                    />
                  </div>
                  <div class="col-12 col-xl-12">
                    <!-- 預約說明 Start -->
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="3"
                      label-size="sm"
                      label="預約說明"
                    >
                      <TrixEditor v-model="bookingPresetBranch.config.basic.tips" />
                    </b-form-group>
                    <!-- 預約說明 End -->
                  </div>
                </div>
                <!-- 表單底部 Start -->
                <div class="d-flex justify-content-center">
                  <b-button
                    class="mr-3"
                    @click="cancel"
                    variant="outline-danger"
                  >
                    返回
                  </b-button>
                  <b-button
                    @click="submit"
                    variant="success"
                  >
                    儲存
                  </b-button>
                </div>
                <!-- 表單底部 End -->
              </section>
              <!-- 基本資料 section end -->
            </b-card>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { zh } from "vuejs-datepicker/dist/locale";
import bookingApi from "@/apis/booking";
import mergeDefaultAndDataModel from "@/utils/mergeDefaultAndDataModel";
import deepGet from "lodash/get";
import { mapGetters } from "vuex";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import TrixEditor from "@/components/TrixEditor.vue";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import _ from 'lodash';
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    AppSingleSelect,
    TrixEditor,
    BreadCrumb
  },
  validations() {
    return {
    };
  },
  computed: {
    consts() {
      return consts;
    },
    ...mapGetters("route", ["routeQuery"]),
    ...mapGetters("general", ["myBranches"]),
    branchOptions() {
      return this.myBranches.map(branch => {
                                let branchName = `${branch.branch_code} ${branch.name}`
                                return {
                                  value: branch.id,
                                  text: branchName
                                }
                              })
    },
  },
  data() {
    return {
      zh,
      slot_people: 0,
      showLoading: false,
      validationErrors: null,
      step: "",
      branchId: null,
      branch: {},
      bookingPresetId: null,
      bookingPresetName: "",
      bookingPresetBranch: {
        config:{
          basic: {
            tips: ""
          },
        },
      },
      option_text: '',
      permissionChecker: new PermissionChecker(),
    };
  },
  mounted() {
    this.bookingPresetId = this.$route.params.id;
    this.branchId = this.$route.params.branch;
    this.branch = this.branchOptions.find(branch => branch.value == this.branchId);

    this.fetchBookingPreset();
  },
  methods: {
    deepGet,
    mergeDefaultAndDataModel,
    goToStep(step) {
      if (!this.bookingPresetId) {
        return;
      }

      if (this.step == step) {
        return;
      }

      this.step = step;
      if (location.hash !== this.step) {
        // NOTE: 這裡不使用 $router.replace，以避免 page rerender 導致 mounted 或其他 lifecycle hook 的內的 API 重複執行
        const newLocation = new URL(location.href);
        newLocation.hash = this.step;
        window.history.replaceState("", "", newLocation.href);
      }
    },
    async submit() {
      try {
        this.showLoading = true;

        await bookingApi.setupBookingPresetBranch(
          this.bookingPresetId,
          this.branchId,
          this.bookingPresetBranch
        );
        await this.fetchBookingPreset();
        this.$swal("儲存成功", "", "success");

        return true;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "儲存失敗", "error");
        return false;
      } finally {
        this.showLoading = false;
      }
    },
    async fetchBookingPreset() {
      if (!this.bookingPresetId) {
        this.$swal("錯誤", "無法取得讀取 ID", "error");
        return;
      }

      try {
        this.showLoading = true;
        let response = await bookingApi.getBookingPreset(this.bookingPresetId, {
          branch_id: this.branchId
        });
        this.bookingPresetName = response.data.data.name;

        if (
            response.data.data.branch_config &&
            typeof response.data.data.branch_config === 'object' &&
            !Array.isArray(response.data.data.branch_config)
        ) {
          this.bookingPresetBranch.config = _.defaultsDeep(
              response.data.data.branch_config,
              {
                basic: {
                  tips: ''
                }
              }
          );
        } else {
          this.bookingPresetBranch.config = {
            basic: {
              tips: ''
            }
          };
        }

      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        // this.cancel();
      } finally {
        this.showLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: "BookingPresetList", query: this.routeQuery });
    },
    formatAndFetchPreset() {
      this.branchId = this.branch.value
      this.fetchBookingPreset()
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-items > li {
  cursor: pointer;

  &.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }

  &.has-checkbox {
    &:after {
      content: "\f134";
      font-family: "Material Design Icons";
      font-size: 16px;
    }
  }

  &.has-checkbox.has-checkbox--checked {
    &:after {
      content: "\f133";
      color: green;
    }
  }
}
</style>
